import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AddAllergyToPatientByUserIdBody } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchAddAllergyToPatientByUserId } from '../api/addAllergyToPatientByUserId.js';
import { rxKeys } from './keys.js';

export interface AddPatientAllergyVariables {
  userId: string;
  data: AddAllergyToPatientByUserIdBody;
}

export function useAddPatientAllergyMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rx', 'patient', 'allergies', 'add'],
    mutationFn: async ({ userId, data }: AddPatientAllergyVariables) => {
      return await fetchAddAllergyToPatientByUserId(userId, data);
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({ queryKey: rxKeys.patientAllergies(variables.userId) });
    },
  });
}
